module.exports = __webpack_public_path__ + "media/audio82.72d8c35e.mp3";